import { axiosInstance, handleApiRequest, handleExportFileRequest } from './apiClient';
import { MessageHistoryResponse, SessionHistoryResponse, SessionNameResponse } from 'types/session';

const sessionAPI = {
  getMessageHistory: async (sessionId: string, chatMode: string = 'bot') => {
    return handleApiRequest<MessageHistoryResponse>(
      axiosInstance.get(`/sessions/${sessionId}?chat_mode=${chatMode}`),
    );
  },
  getSessionHistory: async (
    selectedTopic?: string,
    lastNDays: number = 30,
    limit: number | null = null,
    chatMode: string = 'bot'
  ) => {
    const params = new URLSearchParams();
    if (selectedTopic) {
      params.append('topic', selectedTopic);
    }
    params.append('sort_order', 'desc');
    params.append('last_n_days', lastNDays.toString());
    params.append('chat_mode', chatMode);
    if (limit !== null && limit !== undefined) {
      params.append('limit', limit.toString());
    }
    return handleApiRequest<SessionHistoryResponse>(
      axiosInstance.get(`/sessions/?${params.toString()}`),
    );
  },
  deleteSession: async (sessionId: string, chatMode: string = 'bot') => {
    return handleApiRequest(
      axiosInstance.delete(`/sessions/${sessionId}?chat_mode=${chatMode}`),
    );
  },
  exportSession: async (sessionId: string, fileType: string, fileName: string, chatMode: string = 'bot', exportMode: string = 'bot') => {
    return handleExportFileRequest(
      axiosInstance.get(`/sessions/${sessionId}/export?export_format=${fileType}&chat_mode=${chatMode}&export_mode=${exportMode}`, { responseType: 'blob' }), fileName
    );
  },
  updateSessionName: async (sessionId: string, sessionName: string, chatMode: string = 'bot') => {
    return handleApiRequest<SessionNameResponse>(
      axiosInstance.put(`/sessions/${sessionId}/name?chat_mode=${chatMode}`, {sessionName: sessionName}),
    );
  }
};

export default sessionAPI;
